<template>
    <a href="javascript:void(0);" class="box_col-1 only-mob burger-but" :class="{ 'active' : isOpen }" @click="open">
        <span> </span>
    </a>
</template>

<script>
    export default {
        name: 'MenuButton',
        computed: {
            isOpen() {
                return this.$store.state.isMenuOpen
            },
        },
        methods: {
            open () {
                this.$store.state.isMenuOpen=!this.$store.state.isMenuOpen
                this.$store.state.isBasketOpen=false
            },
            close () {
                this.$store.state.isMenuOpen=false
                this.$store.state.isBasketOpen=false
            }
        },
        created() {
            this.close()
        }
    }
</script>